import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { AppStore } from 'stores';

const LocationForm = ({ onCancel, onSubmit, saving, defaultData }) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      await form.validateFields();
      onSubmit({
        ...values,
        id: defaultData.id,
      });
      form.resetFields();
    } catch (err) {
      AppStore.addError('Validation failed: ' + err.message);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      initialValues={{
        code: defaultData.code,
        description: defaultData.description,
      }}
      layout="vertical"
    >
      <Form.Item
        label="Sub-location"
        name="code"
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Please input the Sub-location!',
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Please input the Description!',
          },
        ]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="default" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          loading={saving}
          style={{ marginLeft: 6 }}
          icon={<SaveOutlined />}
          type="primary"
          htmlType="submit"
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

LocationForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
  defaultData: PropTypes.object,
};

LocationForm.defaultProps = {
  onCancel: () => {},
  onSubmit: () => {},
  saving: false,
  defaultData: {},
};

export default LocationForm;
